import { IconType } from "@common/declarations";
import { useI18n } from "@common/hooks/i18n";
import React from "react";
import Icon from "../Icon/component";
import { useSingleMediaDropdoze } from "./hooks";
import { type UploadSingleMediaPropsBase } from "./types";
import withDropzone, { type WithDropzoneComponentProps } from "./withDropzone";

type Props<T extends {}> = UploadSingleMediaPropsBase<T> & {
  caption?: string;
};
const UploadLink = withDropzone(<T extends {}>(props: Props<T> & WithDropzoneComponentProps) => {
  const i18n = useI18n();

  const { getRootProps, getInputProps } = useSingleMediaDropdoze(props);

  return (
    <span className="dnd_link_upload" {...getRootProps()}>
      <Icon icon={IconType.Add} />
      {props.caption ?? i18n.addFile}

      <input {...getInputProps()} />
    </span>
  );
}) as <T extends object>(props: Props<T>) => any;
export default UploadLink;
